/**
 * A generic filter option with name and count
 */
export class FilterOptionView<T = string> {
	constructor(
		public readonly name: string,
		public readonly count: number,
		public readonly value: T
	) {}
}
